<template>
  <!-- Teleport out of the NavBar (sticky z-[5]) stacking context so the
       overlay's z-index competes at page level and covers the SideBar (z-20). -->
  <Teleport to="body">
    <BaseModal v-model="localModelValue" @close="closeModal" size="logout">
      <template #body>
        <div class="w-full flex flex-col pt-4 gap-8">
          <h1 class="text-center text-font-dark text-[20px] leading-[29px]">{{ t('user.confirm') }}</h1>
          <div class="w-full flex items-center gap-4">
            <BaseButton :is-icon-only="false" variant="red" :is-circle="true" class="flex-1 grow py-[13px]" @click="logoutAccount"> {{ t('user.yes') }} </BaseButton>
            <BaseButton :is-icon-only="false" variant="outlines" :is-circle="true" class="flex-1 grow py-[13px]" @click="closeModal">{{ t('user.no') }}</BaseButton>
          </div>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

<script lang="ts" setup>
import {  ref, watch } from 'vue'
import BaseModal from '@/components/base/BaseModal.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const localModelValue = ref(props.modelValue)
const { t } = useI18n()

const emit = defineEmits(['update:modelValue','logoutAcc'])

watch(
  () => props.modelValue,
  (newValue) => {
    localModelValue.value = newValue
  },
)

watch(localModelValue, (newValue) => {
  emit('update:modelValue', newValue)
})

const closeModal = () => {
  emit('update:modelValue', false)
}

const logoutAccount = () => {
  emit('logoutAcc')
  document.body.style.overflow = ''
}
</script>
